import { DetectMobile } from "./detectmobile";

export function getColorConfig(store) {
  var config = {};

  if (
    !store ||
    !store.ViewComponentConfigs ||
    !store.ViewComponentConfigs.UiColours
  )
    config = {
      Mobile: {},
      Desktop: {}
    };
  else config = store.ViewComponentConfigs.UiColours;

  var styles = getDefaultColor(config);
  return {
    btn: {
      background: styles.ButtonColour,
      color: styles.ButtonText
    },
    CommonColorTxt: {
      color: `${styles.CommonColor} !important`
    },
    StatusPendingTxt: {
      color: `${styles.StatusPending} !important`
    },
    LinkColorTxt: {
      color: `#0000dd !important`
    },
    primaryColor: {
      color: "#ffffff !important"
    },
    alertInfoBackGround: {
      background: styles.CommonColor
    },
    TitleBar: {
      "background-color": styles.TitleBar
    },
    nav: {
      "background-color": `#dddddd !important`
    },
    MenuHighlight: {
      "border-color": `${styles.MenuHighlight} !important`
    },
    MenuHighlightedText: {
      color: `${styles.MenuHighlightedText} !important`
    },
    primaryBodyBackground: {
      "background-color": `#eeeeee !important`
    },
    CommonColorBackground: {
      "background-color": `${styles.CommonColor} !important`
    },
    pendingStatusBackground: {
      "background-color": `${styles.StatusPending} !important`
    }
  };
}

function getDefaultColor(config) {
  var setting = {};
  if (DetectMobile.methods.isMobile()) {
    setting = config.Mobile;
    return {
      ButtonColour: setting.ButtonColour || defaultMobileColors.ButtonColour,
      ButtonText: setting.ButtonText || defaultMobileColors.ButtonText,
      CommonColor: setting.CommonColor || defaultMobileColors.CommonColor,
      MenuHighlight: setting.MenuHighlight || defaultMobileColors.MenuHighlight,
      MenuHighlightedText:
        setting.MenuHighlightedText || defaultMobileColors.MenuHighlightedText,
      StatusPending: setting.StatusPending || defaultMobileColors.StatusPending,
      TitleBar: setting.TitleBar || defaultMobileColors.TitleBar
    };
  } else {
    setting = config.Desktop;
    return {
      ButtonColour: setting.ButtonColour || defaultDesktopColors.ButtonColour,
      ButtonText: setting.ButtonText || defaultDesktopColors.ButtonText,
      CommonColor: setting.CommonColor || defaultDesktopColors.CommonColor,
      MenuHighlight:
        setting.MenuHighlight || defaultDesktopColors.MenuHighlight,
      MenuHighlightedText:
        setting.MenuHighlightedText || defaultDesktopColors.MenuHighlightedText,
      StatusPending:
        setting.StatusPending || defaultDesktopColors.StatusPending,
      TitleBar: setting.TitleBar || defaultDesktopColors.TitleBar
    };
  }
}

export const defaultMobileColors = {
  ButtonColour: "#212529",
  ButtonText: "#ffffff",
  CommonColor: "#55696d",
  MenuHighlight: "#b7bbbb",
  MenuHighlightedText: "#212529",
  StatusPending: "#cfdafd",
  TitleBar: "#626262"
};
export const defaultDesktopColors = {
  ButtonColour: "#212529",
  ButtonText: "#ffffff",
  CommonColor: "#55696d",
  MenuHighlight: "#b7bbbb",
  MenuHighlightedText: "#212529",
  StatusPending: "#cfdafd",
  TitleBar: "#626262"
};
